//
// MapSearchResult.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";

var MapSearchResult = createModule("commons::MapSearchResult", [], EventDispatcher, [
    ,
    ,
    ,
    {
        country: 7,
        address: 7,
        latLon: 11,
        name: 7,
        location: 11,
        nodeId: 3,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default MapSearchResult;
